export const ORG_LIST_PERMISSION = 'organizations:list';
export const ORG_DETAIL_PERMISSION = 'organizations:detail';
export const ORG_EDIT_MEMBER_LIMIT_PERMISSION = 'organizations:edit_member_limit';
export const ORG_EDIT_PROJECT_LIMIT_PERMISSION = 'organizations:edit_project_limit';
export const ORG_EXPORT_POLICY_PERMISSION = 'organizations:manage_export_policy';
export const ORG_ADJUST_PERMISSION = 'organizations:adjust_credits';
export const ORG_GIFT_PERMISSION = 'organizations:gift';

export function canOpenOrgDetail(hasPermission: (code: string) => boolean): boolean {
  return hasPermission(ORG_DETAIL_PERMISSION);
}
